"use client";
import { createContext, useContext } from "react";
const PopupHeaderContext = /*#__PURE__*/ createContext({
    scrim: false
});
function usePopupHeaderContext() {
    return useContext(PopupHeaderContext);
}
export { PopupHeaderContext, usePopupHeaderContext };
